import React, { useContext, useEffect, useMemo } from "react";

import { useParams, useRouteMatch } from "react-router-dom";

import { OfferOptionsContext, OfferStoreContext } from "@gp/components";
import { useRootAppStore } from "@hooks";
import { PeriodConverter } from "@state";
import { FavoritesStoreContext } from "@state/context/favorites/FavoritesStoreContext";
import { LiveOfferMenuStore } from "@state/stores/offer/live/LiveOfferMenuStore";
import MultiEventViewStore from "@state/stores/offer/live/MultiEventViewStore";
import { observer } from "mobx-react";

import EventPageCore from "./components/EventPageCore";

export default observer(function EventPage(props: {
	liveOfferMenuStore?: LiveOfferMenuStore;
}) {
	const params = useParams<{ eventIds: string; period: string }>();
	const match = useRouteMatch("/:culture/live/:period/:eventIds+");
	const rootStore = useRootAppStore();
	const favoritesStore = useContext(FavoritesStoreContext);
	const multiEventViewStore = useMemo(
		() =>
			new MultiEventViewStore(
				rootStore,
				props.liveOfferMenuStore,
				favoritesStore
			),
		[]
	);

	useEffect(() => {
		multiEventViewStore.updateEventIds(params.eventIds);
		multiEventViewStore.onInitialize(params.period);
		rootStore.eventSwitcherViewStore.onInitialize();
	}, [params.eventIds]);

	useEffect(() => {
		window.scrollTo(0, 0);

		return () => {
			multiEventViewStore.onDispose();
			rootStore?.eventSwitcherViewStore?.onDispose();
		};
	}, []);

	return (
		<div className="l--content__main">
			<div className="row">
				<OfferStoreContext.Provider value={multiEventViewStore}>
					<OfferOptionsContext.Provider
						value={{
							/* @ts-expect-error */
							shouldDisplayShowMore: !!match,
							isOfferHistory: PeriodConverter.IsDateString(
								params.period
							),
							isHistoryEvent: (id: string) =>
								multiEventViewStore.isHistoryEvent(id),
						}}
					>
						{[...multiEventViewStore.eventsViewMap.values()].map(
							(eventViewStore) => (
								<EventPageCore
									store={eventViewStore}
									key={eventViewStore.eventId}
								/>
							)
						)}
					</OfferOptionsContext.Provider>
				</OfferStoreContext.Provider>
			</div>
		</div>
	);
});
